// Hostro brand logo — uses the official wordmark image uploaded by the founders.
// `variant="full"` shows the wordmark image; `variant="icon"` shows just the house symbol.
// Tagline is shown only when `showTagline` is true (e.g. login page hero, footer top).

const LOGO_URL = "https://customer-assets.emergentagent.com/job_student-housing-hub-32/artifacts/r2nymkhu_WhatsApp%20Image%202026-06-07%20at%2003.37.00.jpeg";

export default function HostroLogo({ size = 36, variant = "full", showTagline = false, dark = false }) {
  if (variant === "icon") {
    // Compact rounded-square house icon — used in favicons & mobile pill.
    return (
      <div className="flex items-center" data-testid="hostro-logo-icon">
        <svg
          width={size}
          height={size}
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Hostro"
        >
          <rect x="2" y="2" width="44" height="44" rx="10" fill="#34C97B"/>
          <path d="M11 24 L24 12 L37 24 L37 36 Q37 38 35 38 L13 38 Q11 38 11 36 Z" fill="#FFFFFF"/>
          <rect x="20" y="26" width="8" height="12" rx="1.5" fill="#34C97B"/>
        </svg>
      </div>
    );
  }

  // Full wordmark — uses the uploaded "hostro" image with proper proportions.
  // We crop the image (object-cover with focal point) so on small heights we
  // still see the "hostro" word, not whitespace.
  return (
    <div className="flex items-center gap-2" data-testid="hostro-logo">
      <div
        className="overflow-hidden flex items-center justify-center"
        style={{ height: size, width: size * 2.6 }}
      >
        <img
          src={LOGO_URL}
          alt="Hostro — One Platform. Endless Possibilities."
          className="object-contain"
          style={{
            height: size * 1.7,                    // crop the whitespace by zooming in
            width: size * 2.6,
            objectFit: "cover",
            objectPosition: "center 35%",          // keep wordmark centered, crop the tagline area
            filter: dark ? "invert(1) hue-rotate(180deg) saturate(1.3)" : "none",
          }}
          loading="eager"
        />
      </div>
      {showTagline && (
        <span
          className="hidden md:inline text-xs font-medium tracking-tight"
          style={{ color: dark ? "rgba(255,255,255,0.8)" : "#111111" }}
        >
          One Platform. Endless Possibilities.
        </span>
      )}
    </div>
  );
}
